import React, { useEffect, useState } from "react";
import {
  getFollowUps,
  getStudents,
  createFollowUp,
  updateFollowUp,
  FollowUp,
  Student,
} from "../api/client";

export default function FollowUps() {
  const [followUps, setFollowUps] = useState<FollowUp[]>([]);
  const [students, setStudents] = useState<Student[]>([]);
  const [filter, setFilter] = useState<string>("");
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ student_id: "", reason: "", type: "custom", notes: "" });

  const load = () => {
    getFollowUps(undefined, filter || undefined).then((r) => setFollowUps(r.data));
    getStudents().then((r) => setStudents(r.data));
  };

  useEffect(() => { load(); }, [filter]);

  const studentName = (id: string) => students.find((s) => s.id === id)?.name || "Unknown";

  const handleCreate = async () => {
    if (!form.student_id || !form.reason) return;
    await createFollowUp(form);
    setForm({ student_id: "", reason: "", type: "custom", notes: "" });
    setShowModal(false);
    load();
  };

  const handleStatusChange = async (id: string, status: string) => {
    await updateFollowUp(id, { status });
    load();
  };

  return (
    <div>
      <div className="toolbar">
        <h2>Follow-ups</h2>
        <div style={{ display: "flex", gap: 8 }}>
          <select value={filter} onChange={(e) => setFilter(e.target.value)} style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #ddd" }}>
            <option value="">All</option>
            <option value="pending">Pending</option>
            <option value="contacted">Contacted</option>
            <option value="resolved">Resolved</option>
            <option value="dismissed">Dismissed</option>
          </select>
          <button className="btn btn-primary" onClick={() => setShowModal(true)}>
            + Add Follow-up
          </button>
        </div>
      </div>

      <div className="table-container">
        {followUps.length === 0 ? (
          <div className="empty">No follow-ups</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Student</th>
                <th>Type</th>
                <th>Reason</th>
                <th>Status</th>
                <th>Created</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {followUps.map((f) => (
                <tr key={f.id}>
                  <td>{studentName(f.student_id)}</td>
                  <td><span className="badge">{f.type}</span></td>
                  <td>{f.reason}</td>
                  <td><span className={`badge ${f.status}`}>{f.status}</span></td>
                  <td>{new Date(f.created_at).toLocaleDateString()}</td>
                  <td>
                    {f.status === "pending" && (
                      <div style={{ display: "flex", gap: 4 }}>
                        <button className="btn btn-secondary btn-sm" onClick={() => handleStatusChange(f.id, "contacted")}>
                          Contacted
                        </button>
                        <button className="btn btn-secondary btn-sm" onClick={() => handleStatusChange(f.id, "resolved")}>
                          Resolve
                        </button>
                        <button className="btn btn-secondary btn-sm" onClick={() => handleStatusChange(f.id, "dismissed")}>
                          Dismiss
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Add Follow-up</h3>
            <div className="form-group">
              <label>Student *</label>
              <select value={form.student_id} onChange={(e) => setForm({ ...form, student_id: e.target.value })}>
                <option value="">Select student...</option>
                {students.map((s) => (
                  <option key={s.id} value={s.id}>{s.name}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Type *</label>
              <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
                <option value="absent">Absent</option>
                <option value="missing_homework">Missing Homework</option>
                <option value="low_score">Low Score</option>
                <option value="declining">Declining</option>
                <option value="custom">Custom</option>
              </select>
            </div>
            <div className="form-group">
              <label>Reason *</label>
              <textarea value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} />
            </div>
            <div className="form-group">
              <label>Notes</label>
              <textarea value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
            </div>
            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={handleCreate}>Create</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
